/**
 * Shared helpers for talking to the backend over plain `fetch`.
 *
 * Every backend request carries the `x-fraud-front-channel: web` header so the
 * backend can attribute server-side PostHog events (the `backend_request`
 * event's `channel` property) to the web client precisely, instead of inferring
 * the channel from the cookie session. The typed `openapi-fetch` client in
 * `react-query.ts` injects the same header at its own chokepoint; use `apiFetch`
 * for any plain `fetch` to `/api/*` so the two paths stay consistent.
 */
export const CLIENT_CHANNEL_HEADER = 'x-fraud-front-channel';
export const CLIENT_CHANNEL = 'web';

export const apiFetch = (
  input: RequestInfo | URL,
  init: RequestInit = {}
): Promise<Response> => {
  const headers = new Headers(init.headers);
  if (!headers.has(CLIENT_CHANNEL_HEADER)) {
    headers.set(CLIENT_CHANNEL_HEADER, CLIENT_CHANNEL);
  }
  // credentials default to 'include'; callers can still override via init.
  return fetch(input, { credentials: 'include', ...init, headers });
};
